import COLORS from './Colors';

export interface Character {
    name: string;
    displayName: string;
    color: string;
}

const CHARACTERS: Record<string, Character> = {
    schooltv: {
        name: 'schooltv',
        displayName: 'Schooltv',
        color: COLORS.PRIMARY,
    },
    chip_ai: {
        name: 'chip_ai',
        displayName: 'Chip AI',
        color: COLORS.SECONDARY,
    },
    annique: {
        name: 'annique',
        displayName: 'Annique',
        color: COLORS.BLUE,
    },
    devran: {
        name: 'devran',
        displayName: 'Devran',
        color: COLORS.PRIMARY,
    },
    angelique_van_ombergen: {
        name: 'angelique_van_ombergen',
        displayName: 'Angelique',
        color: COLORS.INDIGO,
    },
    marleen_de_rooy: {
        name: 'marleen_de_rooy',
        displayName: 'Marleen',
        color: COLORS.PRIMARY,
    },
};

export default CHARACTERS;
